import qs from 'qs';
import _ from 'lodash';
import axios from '@/axios.js';

const state = {
  activities: [],
}

const mutations = {
  SET_ACTIVITIES: (state, payload) => {
    state.activities = payload;
  },
  SET_ACTIVITY: (state, payload) => {
    state.activity = payload;
  },
  SET_EXECUTIONS: (state, payload) => {
    state.executions = payload;
  },
  SET_WORKERS: (state, payload) => {
    state.workers = payload;
  },
  SET_EVENTS: (state, payload) => {
    state.events = payload;
  },
  SET_FLEETS: (state, payload) => {
    state.fleets = payload;
  },
  SET_STATISTICS: (state, payload) => {
    state.statistics = payload;
  },
  SET_EVENT_WORKERS: (state, payload) => {
    state.eventWorkers = payload;
  },
};

const actions = {
  activities: ({ commit }, options) => {
    const skip = ((options.page || 1) - 1) * (options.itemsPerPage || 10);
    const filter = options;
    const params = _.omitBy({
      skip,
      limit: options.itemsPerPage || 10,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
      ...filter,
    }, _.isUndefined);

    return axios.get(`/atlas/activities?${qs.stringify(params)}`)
      .then((response) => {
      commit('SET_ACTIVITIES', response.data);
      return response.data;
    });
  },
  activity: ({ commit }, id) => {
    const params = {};

    return axios.get(`/atlas/activities/${id}?${qs.stringify(params)}`)
      .then((response) => {
      commit('SET_ACTIVITY', response.data);
      return response.data;
    });
  },
  updateActivity: ({ commit }, item) => {
    const params = {};

    return axios.put(`/atlas/activities/${item._id}?${qs.stringify(params)}`, {
      item,
    })
      .then((response) => {
      commit('SET_ACTIVITY', response.data);
      return response.data;
    });
  },
  executions: ({ commit }, options) => {
    const skip = ((options.page || 1) - 1) * (options.itemsPerPage || 10);
    const filter = options;
    const params = _.omitBy({
      skip,
      limit: options.itemsPerPage || 10,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
      ...filter,
    }, _.isUndefined);

    return axios.get(`/atlas/activities/executions?${qs.stringify(params)}`)
      .then((response) => {
      commit('SET_EXECUTIONS', response.data);
      return response.data;
    });
  },
  sendCommand: (c, { account, command }) => {
    return axios.post(`/accounts/${account}/command`, {
      service: 'atlas',
      command,
    })
      .then((response) => {
        return response.data;
      });
  },
  getWorkers: ({ commit }) => {
    return axios.get('/atlas/activities/executions/workers').then((response) => {
      commit('SET_WORKERS', response.data);
      return response.data;
    });
  },
  events: ({ commit }, options) => {
    const skip = ((options.page || 1) - 1) * (options.itemsPerPage || 10);
    const filter = options;
    const params = _.omitBy({
      skip,
      limit: options.itemsPerPage || 10,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
      ...filter,
    }, _.isUndefined);

    return axios.get(`/atlas/events?${qs.stringify(params)}`).then((response) => {
      commit('SET_EVENTS', response.data);
      return response.data;
    });
  },

  statistics: ({ commit }, options) => {
    const skip = ((options.page || 1) - 1) * (options.itemsPerPage || 10);
    const filter = options;
    const params = _.omitBy({
      skip,
      limit: options.itemsPerPage || 10,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
      ...filter,
    }, _.isUndefined);


    return axios.get(`/atlas/events/statistics?${qs.stringify(params)}`).then((response) => {
      commit('SET_STATISTICS', response.data);
      return response.data;
    });
  },

  eventWorkers: ({ commit }) => {
    return axios.get(`/atlas/events/workers`).then((response) => {
      commit('SET_EVENT_WORKERS', response.data);
      return response.data;
    });
  },

  fleets: ({ commit }) => {
    return axios.get(`/atlas/fleets`).then((response) => {
      commit('SET_FLEETS', response.data);
      return response.data;
    });
  },
};

const getters = {};

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

